import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject ,  Observable } from 'rxjs';
// import { Http, Response, Headers } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Configuration } from './../../app.constants';
@Injectable()

export class GetDataService {
    private roles_list = [];

    constructor(
        private router: Router,
        private _http: HttpClient,
        private config:Configuration
    ) { }

    public roles() {
        const simpleObservable = new Observable((observer) => {
            this._http.get(`${this.config.ServerApiUrl}/getData`)
            .subscribe((data) => {
                console.log('This is the data');
                for (let i = 0 ; i < Object.keys(data).length ; i++) {
                    let temp = {};
                    temp['role'] = 'role';
                    temp['value'] = data[i].key;
                    this.roles_list.push(temp);
                }
                console.log(data);
            }, (err) => {
                console.log('Error occured while fetching data from api');
                console.log(err);
            });
            observer.next(this.roles_list);
        });
        return simpleObservable;
    }
}






